import React, { useState } from 'react';
import { calculate, formatArea, formatPercent } from '../lib/calculations';

const baseVolumes = { trunk: 0.5, head: 0.07, arm: 0.05, leg: 0.165 };
const lengths = { trunk: 0.30, head: 0.13, arm: 0.44, leg: 0.50 };

function psi(trunkVolume) {
  const scale = (1 - trunkVolume) / (1 - baseVolumes.trunk);
  const terms = [
    Math.sqrt(trunkVolume * lengths.trunk),
    Math.sqrt(baseVolumes.head * scale * lengths.head),
    2 * Math.sqrt(baseVolumes.arm * scale * lengths.arm),
    2 * Math.sqrt(baseVolumes.leg * scale * lengths.leg)
  ];
  return terms.reduce((total, value) => total + value, 0);
}

export default function BiotypeExplorer() {
  const [concentration, setConcentration] = useState(0.5);
  const height = 170;
  const weight = 70;
  const mosteller = calculate(height, weight).Mosteller;
  const experimental = mosteller * psi(concentration) / psi(0.5);
  const difference = (experimental - mosteller) / mosteller * 100;

  return (
    <section className="panel biotype-panel" aria-labelledby="biotype-title">
      <span className="eyebrow">SIMULAÇÃO DIDÁTICA · HIPÓTESE DE PESQUISA · NÃO VALIDADA</span>
      <h2 id="biotype-title">Explorador de biótipo</h2>
      <p>Este modelo geométrico simplificado mantém altura (170 cm) e peso (70 kg) fixos e redistribui frações de volume entre segmentos. Não representa anatomia real.</p>
      <label className="biotype-slider">Concentração de massa no tronco: <strong>{Math.round(concentration * 100)}%</strong>
        <input type="range" min="0.45" max="0.55" step="0.05" value={concentration} onChange={event => setConcentration(Number(event.target.value))} aria-valuetext={`${Math.round(concentration * 100)} por cento`} />
      </label>
      <div className="biotype-values" aria-live="polite">
        <div><span>Mosteller de referência</span><strong>{formatArea(mosteller)} m²</strong></div>
        <div><span>SC experimental</span><strong>{formatArea(experimental)} m²</strong></div>
        <div><span>Diferença do modelo</span><strong>{formatPercent(difference)}%</strong></div>
      </div>
      <p className="biotype-explanation">A simulação soma raízes quadradas do produto entre frações de volume e de comprimento: tronco (0,30 da altura), cabeça e pescoço (0,13), cada braço (0,44) e cada perna (0,50). As frações de volume de base são, respectivamente, 0,50; 0,07; 0,05 por braço; e 0,165 por perna. Ao variar o tronco, os demais volumes são reduzidos ou aumentados proporcionalmente. No modelo, concentrar mais massa no tronco tende a reduzir a área estimada porque a massa fica associada a um segmento relativamente curto; distribuí-la pelos segmentos mais longos aumenta a soma geométrica.</p>
      <p className="formula-warning"><strong>Simulação ilustrativa, não validada:</strong> não usar para decisões clínicas.</p>
    </section>
  );
}
